import React, { useEffect, useState } from "react";
import styles from "./tripDetails.module.css";
import DrawerTrip from "./TripDrawer";
import TripMapContainer from "../../../components/TripMapContainer";
import { post } from "../../../components/api";
import moment from "moment";
import { useLocation } from "react-router-dom";

const Tripdetails = () => {
  const location = useLocation();
  const tripData = location.state?.tripData;
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [routeData, setRouteData] = useState([]);
  const [isHistoryLoading, setIsHistoryLoading] = useState(false);
  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const routeHistoryData = async () => {
    setIsHistoryLoading(true);
    let data = {
      vehicleNo: "GJ27TD6391",
      timeFilter: "range",
      startDate: moment([2025, 0, 1]),
      endDate: moment([2025, 0, 10]),
    };

    const routedata = await post("company/ltms/get-route-history", data);

    if (routedata.status == 200) {
      setRouteData(routedata.data);
      setIsHistoryLoading(false);
    } else {
      setIsHistoryLoading(true);
    }
  };

  useEffect(() => {
    routeHistoryData();
  }, []);
  return (
    <div className={styles.tripDetail}>
      <div className={styles.Heading}>
        <p>Tips Details</p>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className={styles.firstCard}>
            <div className={styles.firstCard_mainBackground}>
              <div className={styles.firstCard_firstDiv}>
                <div className={styles.firstCard_firstDiv_1}>
                  <p className={styles.firstCard_firstDiv_1_label}>Trip ID:</p>
                  <p className={styles.firstCard_firstDiv_1_Id}>
                    #{tripData?.tripId}
                  </p>
                </div>
                <div className={styles.firstCard_firstDiv_1}>
                  <p className={styles.firstCard_firstDiv_1_label}>
                    Trip Status
                  </p>
                  <div className={styles.firstCard_firstDiv_tag}>
                    <p style={{ textAlign: "center" }}>{tripData?.status}</p>
                  </div>
                </div>
              </div>
              <div className={styles.firstCard_secondDiv}>
                <div className={styles.svg}>
                  <svg
                    width="12"
                    height="96"
                    viewBox="0 0 12 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6 8L6 90"
                      stroke="#44585F"
                      strokeWidth="0.228645"
                      strokeDasharray="1.14 1.14"
                    />
                    <circle
                      cx="6"
                      cy="94.1458"
                      r="6"
                      fill="#33C154"
                      fillOpacity="0.5"
                    />
                    <circle cx="6" cy="94.1458" r="4.5" fill="#33C154" />
                    <circle
                      cx="6"
                      cy="6"
                      r="6"
                      fill="#E57556"
                      fillOpacity="0.5"
                    />
                    <circle cx="6" cy="6" r="4.5" fill="#E57556" />
                  </svg>
                </div>
                <div className={styles.firstCard_secondDiv_Address}>
                  <div className={styles.firstCard_secondDiv_Address1}>
                    <p
                      className={styles.city}
                    >{`${tripData?.loads?.loadId?.fromCity?.city},${tripData?.loads?.loadId?.fromCity?.state}`}</p>
                    <p className={styles.address}>
                      {tripData?.loads?.loadId?.fromCity?.name}
                    </p>
                  </div>
                  <div className={styles.firstCard_secondDiv_Address1}>
                    <p
                      className={styles.city}
                    >{`${tripData?.loads?.loadId?.toCity?.city},${tripData?.loads?.loadId?.toCity?.state}`}</p>
                    <p className={styles.address}>
                      {tripData?.loads?.loadId?.toCity?.name}
                    </p>
                  </div>
                </div>
              </div>
              <div className={`row ${styles.firstCard_thirdDiv}`}>
                <div className="col-md-4" style={{ marginBottom: "10px" }}>
                  <p className={styles.secondaryText}>Trip Started Date</p>
                  <p className={styles.MainText}>
                    {moment(tripData?.loads?.loadId?.loadingDate)
                      .add(5, "hours")
                      .add(30, "minutes")
                      .format("DD/MM/YYYY HH:mm")}
                  </p>
                </div>
                <div className="col-md-4">
                  <p className={styles.secondaryText}>Delivery Date</p>
                  <p className={styles.MainText}>
                    {" "}
                    {moment(tripData?.loads?.loadId?.deliveryDate)
                      .add(5, "hours")
                      .add(30, "minutes")
                      .format("DD/MM/YYYY HH:mm")}
                  </p>
                </div>
                <div className="col-md-4">
                  <p className={styles.secondaryText}>Total Distance</p>
                  <p className={styles.MainText}>
                    {tripData.loads.distance} km
                  </p>
                </div>
                <div className="col-md-4">
                  <p className={styles.secondaryText}>Estimated Duration</p>
                  <p className={styles.MainText}>
                    {tripData.loads.estimatedDuration} hrs
                  </p>
                </div>
                <div className="col-md-4">
                  <p className={styles.secondaryText}>Actual Duration</p>
                  <p className={styles.MainText}>52 hrs</p>
                </div>
                <div className="col-md-4">
                  <div className={styles.statusTag}>
                    <p className={styles.label}>Delay</p>
                    <p className={styles.status}>+2 hours</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.secondCard}>
            <div className={styles.firstCard_mainBackground}>
              <div className="row">
                <div className="col-md-4">
                  <div>
                    <p className={styles.secondaryText}>Fleet Owner Name</p>
                    <p className={styles.MainText}>ABC Logistics</p>
                  </div>
                  <div>
                    <p className={styles.secondaryText}>KYC Status</p>
                    <p className={styles.MainText}>Verification</p>
                  </div>
                </div>
                <div className="col-md-4">
                  <div>
                    <p className={styles.secondaryText}>Mobile No</p>
                    <p className={styles.MainText}>+91 90990 90990</p>
                  </div>
                  <div>
                    <p className={styles.secondaryText}>Truck Number</p>
                    <p className={styles.MainText}>
                      {tripData?.loads?.loadId?.vehicleId?.vehicleNo}
                    </p>
                  </div>
                </div>

                <div className={`col-md-4 ${styles.mainDivOfStatusTag}`}>
                  <div className={styles.statusTag2}>
                    <p className={styles.label}>Payment Status</p>
                    <p className={styles.status}>
                      {" "}
                      <svg
                        width="7"
                        height="7"
                        viewBox="0 0 7 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <circle cx="3.5" cy="3.5" r="3.5" fill="#21CB49" />
                      </svg>
                      Paid
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.thirdCard}>
            <div className={styles.firstCard_mainBackground}>
              <div style={{ marginBottom: "10px" }}>
                <p className={styles.secondaryText}>Product</p>
                <p className={styles.MainText}>Electronics</p>
              </div>
              <div>
                <p className={styles.secondaryText}>Remarks</p>
                <p className={styles.address}>
                  Lorem Ipsum is simply dummy text of the printing and
                  typesetting industry. Lorem Ipsum has been the industrys
                  standard dummy text ever since the 1500s, when an unknown
                  printer took a galley of type and scrambled it to make a type
                  specimen book. It has survived not only five centuries, but
                  also the leap into electronic typesetting, remaining
                  essentially unchanged.
                </p>
              </div>
            </div>
          </div>
          <div className={styles.fourthCard}>
            <div className={styles.firstCard_mainBackground}>
              <p
                className={styles.secondaryText}
                style={{ marginBottom: "10px" }}
              >
                Documents
              </p>
              <div className={styles.fourthCard_firstDiv}>
                <svg
                  width="41"
                  height="40"
                  viewBox="0 0 41 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M35.4716 38.6966H15.2019C12.6577 38.6966 10.5952 36.6341 10.5952 34.0899V5.5281C10.5952 2.98386 12.6577 0.921348 15.2019 0.921348H27.4888L40.0783 13.5108V34.0899C40.0783 36.6341 38.0158 38.6966 35.4716 38.6966Z"
                    fill="#EEF1F7"
                    stroke="#CBD0DC"
                    strokeWidth="1.8427"
                  />
                  <rect
                    y="17.5056"
                    width="27.6404"
                    height="16.1236"
                    rx="3.22472"
                    fill="#D82042"
                  />
                  <path
                    d="M4.58105 29.4832V21.7773H7.32776C7.92727 21.7773 8.42393 21.8865 8.81775 22.1047C9.21157 22.3229 9.50631 22.6214 9.70196 23.0002C9.89762 23.3765 9.99545 23.8004 9.99545 24.272C9.99545 24.746 9.89637 25.1725 9.6982 25.5512C9.50255 25.9275 9.20655 26.226 8.81023 26.4467C8.41641 26.665 7.921 26.7741 7.324 26.7741H5.43517V25.7883H7.21864C7.59741 25.7883 7.90469 25.7231 8.14048 25.5926C8.37627 25.4597 8.54935 25.2791 8.65972 25.0508C8.77009 24.8225 8.82528 24.5629 8.82528 24.272C8.82528 23.981 8.77009 23.7226 8.65972 23.4969C8.54935 23.2711 8.37502 23.0943 8.13672 22.9663C7.90093 22.8384 7.58989 22.7744 7.20359 22.7744H5.7437V29.4832H4.58105Z"
                    fill="white"
                  />
                  <path
                    d="M13.8531 29.4832H11.3585V21.7773H13.9321C14.6871 21.7773 15.3355 21.9316 15.8773 22.2401C16.4192 22.5462 16.8343 22.9864 17.1228 23.5608C17.4137 24.1327 17.5592 24.8188 17.5592 25.619C17.5592 26.4217 17.4125 27.1115 17.119 27.6884C16.828 28.2653 16.4066 28.7093 15.8548 29.0204C15.3029 29.3289 14.6357 29.4832 13.8531 29.4832ZM12.5211 28.4673H13.7891C14.3761 28.4673 14.864 28.3569 15.2528 28.1362C15.6416 27.9129 15.9325 27.5906 16.1257 27.1692C16.3188 26.7452 16.4154 26.2285 16.4154 25.619C16.4154 25.0144 16.3188 24.5015 16.1257 24.0801C15.935 23.6586 15.6503 23.3388 15.2716 23.1206C14.8928 22.9024 14.4225 22.7932 13.8606 22.7932H12.5211V28.4673Z"
                    fill="white"
                  />
                  <path
                    d="M19.005 29.4832V21.7773H23.7835V22.7782H20.1677V25.1261H23.4411V26.1232H20.1677V29.4832H19.005Z"
                    fill="white"
                  />
                </svg>
                <div>
                  <p className={styles.Document_text}>Ongoing Trip</p>
                  <p className={styles.secondaryText}>
                    Invoice Document for Current and Ongoing Trips
                  </p>
                </div>
              </div>
              <div className={styles.fourthCard_firstDiv}>
                <svg
                  width="41"
                  height="40"
                  viewBox="0 0 41 40"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M35.4716 38.6966H15.2019C12.6577 38.6966 10.5952 36.6341 10.5952 34.0899V5.5281C10.5952 2.98386 12.6577 0.921348 15.2019 0.921348H27.4888L40.0783 13.5108V34.0899C40.0783 36.6341 38.0158 38.6966 35.4716 38.6966Z"
                    fill="#EEF1F7"
                    stroke="#CBD0DC"
                    strokeWidth="1.8427"
                  />
                  <rect
                    y="17.5056"
                    width="27.6404"
                    height="16.1236"
                    rx="3.22472"
                    fill="#D82042"
                  />
                  <path
                    d="M4.58105 29.4832V21.7773H7.32776C7.92727 21.7773 8.42393 21.8865 8.81775 22.1047C9.21157 22.3229 9.50631 22.6214 9.70196 23.0002C9.89762 23.3765 9.99545 23.8004 9.99545 24.272C9.99545 24.746 9.89637 25.1725 9.6982 25.5512C9.50255 25.9275 9.20655 26.226 8.81023 26.4467C8.41641 26.665 7.921 26.7741 7.324 26.7741H5.43517V25.7883H7.21864C7.59741 25.7883 7.90469 25.7231 8.14048 25.5926C8.37627 25.4597 8.54935 25.2791 8.65972 25.0508C8.77009 24.8225 8.82528 24.5629 8.82528 24.272C8.82528 23.981 8.77009 23.7226 8.65972 23.4969C8.54935 23.2711 8.37502 23.0943 8.13672 22.9663C7.90093 22.8384 7.58989 22.7744 7.20359 22.7744H5.7437V29.4832H4.58105Z"
                    fill="white"
                  />
                  <path
                    d="M13.8531 29.4832H11.3585V21.7773H13.9321C14.6871 21.7773 15.3355 21.9316 15.8773 22.2401C16.4192 22.5462 16.8343 22.9864 17.1228 23.5608C17.4137 24.1327 17.5592 24.8188 17.5592 25.619C17.5592 26.4217 17.4125 27.1115 17.119 27.6884C16.828 28.2653 16.4066 28.7093 15.8548 29.0204C15.3029 29.3289 14.6357 29.4832 13.8531 29.4832ZM12.5211 28.4673H13.7891C14.3761 28.4673 14.864 28.3569 15.2528 28.1362C15.6416 27.9129 15.9325 27.5906 16.1257 27.1692C16.3188 26.7452 16.4154 26.2285 16.4154 25.619C16.4154 25.0144 16.3188 24.5015 16.1257 24.0801C15.935 23.6586 15.6503 23.3388 15.2716 23.1206C14.8928 22.9024 14.4225 22.7932 13.8606 22.7932H12.5211V28.4673Z"
                    fill="white"
                  />
                  <path
                    d="M19.005 29.4832V21.7773H23.7835V22.7782H20.1677V25.1261H23.4411V26.1232H20.1677V29.4832H19.005Z"
                    fill="white"
                  />
                </svg>
                <div>
                  <p className={styles.Document_text}>Ongoing Trip</p>
                  <p className={styles.secondaryText}>
                    Invoice Document for Current and Ongoing Trips
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className={styles.googleMapContainer}>
            <TripMapContainer
              origin={{ lat: 23, lng: 72.6 }}
              destination={{ lat: 28.2, lng: 77.5 }}
              tripData={tripData}
            />
          </div>
          <div className={styles.routeHistoryDiv}>
            <button className={styles.routeHistory}>Live</button>
            <button className={styles.routeHistory} onClick={toggleDrawer}>
              Route History
            </button>
          </div>
        </div>
      </div>
      {drawerOpen && (
        <DrawerTrip
          show={drawerOpen}
          closeDrawer={toggleDrawer}
          data={routeData.data}
          isLoading={isHistoryLoading}
          totalRunTime={routeData.totalRunTime}
          stopTime={routeData.stopTime}
        />
      )}
    </div>
  );
};

export default Tripdetails;

{
  /* <div className={styles.secondCard}>
<div className={styles.firstCard_mainBackground}>
  <div className={styles.secondCard_firstDiv}>
    <div>
      <p className={styles.secondaryText}>Fleet Owner Name</p>
      <p className={styles.MainText}>ABC Logistics</p>
    </div>
    <div>
      <p className={styles.secondaryText}>Mobile No</p>
      <p className={styles.MainText}>+91 90990 90990</p>
    </div>
    <div>
      <p>{""}</p>
      <p>{""}</p>
    </div>
  </div>
  <div className={`row ${styles.secondCard_secondDiv}`}>
    <div className="col-md-4">
      <div>
      <p className={styles.secondaryText}>Fleet Owner Name</p>
      <p className={styles.MainText}>ABC Logistics</p>
      </div>
      <div>
        
      </div>
    </div>

    <div>
      <p className={styles.secondaryText}>Mobile No</p>
      <p className={styles.MainText}>+91 90990 90990</p>
    </div>

    <div className={styles.statusTag2}>
      <p>Payment Status</p>
    </div>
  </div>
</div>
</div> */
}
